import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import classNames from 'classnames';

export const DEFAULT_SELECTED_FILE_FIELD = 'Choose file...';

export type TUploadFile = {
    handleUploadFile: (event: any) => void;
    uploadPercentage: number;
    fileName: string;
};

export function UploadFile({
    handleUploadFile,
    uploadPercentage,
    fileName,
}: TUploadFile) {
    return (
        <div className="UploadFile progres-bar-content">
            <label className="file">
                <input
                    type="file"
                    id="file"
                    aria-label="File browser"
                    onChange={handleUploadFile}
                    disabled={!!uploadPercentage}
                />
                <span
                    className={classNames('file-custom', {
                        'file-custom-disabled': !!uploadPercentage,
                    })}
                    data-value={fileName ?? DEFAULT_SELECTED_FILE_FIELD}
                />
            </label>
            {uploadPercentage > 0 && (
                <ProgressBar
                    now={uploadPercentage}
                    label={`${uploadPercentage}%`}
                    active={true}
                />
            )}
        </div>
    );
}
